<template>

    <form @submit.prevent="" class="filter-panel">
        <div class="search-wrapper mr-2">
            <input class="form-control"
                :placeholder="trans('search-placeholder')"
                v-model="searchString"
                @keyup.enter="searchOnchange($event.target.value)"
                :disabled="disabled" />
        </div>

        <div style="width: 120px" class="mr-2" v-for="(filter, idx) in filtersMutable" :key="filter.key + '-' + idx">
            <dropdown-multichoice
                :name="filter.key"
                :label="filter.label"
                :title="filter.title"
                :options="filter.options"
                :checked="filter.values"
                :onchange="filterOnchange"
                :resetTrigger="resetTrigger"
                :disabled="disabled"
            ></dropdown-multichoice>
        </div>

        <div class="ms-auto">
            <button type="button" class="btn btn-primary" @click="submit()" :disabled="disabled">
                <i class="far fa-search"></i>
            </button>

            <button type="button" class="btn btn-link btn-cancel-filter" @click="reset()" v-if="filterChanged" :disabled="disabled" v-b-tooltip.hover v-b-tooltip.hover.top :title="trans('reset')">
                <i class="far fa-filter text-dark"></i>
                <i class="far fa-times-circle text-danger"></i>
            </button>
        </div>
    </form>

</template>

<script>
    import TranslationsUtils from "../../app-components/TranslationsUtils";
    import {cloneDeep} from "lodash";

    export default {
        mixins: [TranslationsUtils],
        props: {
            'search': { type: String, default: '' },
            'filters': { type: Array, default: [] },
            'onchange': { type: Function },
            'disabled': { type: Boolean, default: false },
        },

        data() {
            return {
                searchString: this.search,
                searchStringSaved: this.search,
                filtersMutable: cloneDeep(this.filters),
                filterData: this.filters.reduce((acc, item) => { acc[item.key] = item.values; return acc; }, {}),
                resetTrigger: 0
            };
        },

        methods: {
            searchOnchange(newValue) {
                this.searchString = newValue;
                this.submit();
            },

            filterOnchange (name, values) {
                this.filterData[name] = values;
            },

            submit() {
                this.filtersMutable.forEach(filter => {
                    filter.values = this.filterData[filter.key];
                });
                this.searchStringSaved = this.searchString;
                this.onchange(this.searchString, this.filtersMutable);
            },

            reset() {
                // reset to original default state, not previously saved
                this.searchString = '';
                this.searchStringSaved = '';
                this.filtersMutable = this.filters.map(filter => ({ ...filter, values: filter.defaultValues }));
                this.filterData = this.filters.reduce((acc, item) => {
                    acc[item.key] = item.defaultValues;
                    return acc;
                }, {});

                this.resetTrigger++;
                this.onchange(this.searchString, this.filtersMutable);
            }
        },

        computed: {
            filterChanged() {
                if(this.searchStringSaved !== '') {
                  return true;
                }

                return JSON.stringify(cloneDeep(this.filters).reduce((acc, item) => { acc[item.key] = item.values; return acc; }, {}))
                   !== JSON.stringify(cloneDeep(this.filters).reduce((acc, item) => { acc[item.key] = item.defaultValues; return acc; }, {}));
            },
        }

    }
</script>


<style lang="scss">
    .filter-panel {
        display: flex;
        justify-content: start;
        margin-top: 1rem;

        .search-wrapper {
            width: 200px;
        }

        .form-control {
            &:disabled {
                background: white;
                opacity: 0.7;
            }
        }

        .btn-primary {
            &:disabled {
                background: #4273fa;
                border-color: #4273fa;
                opacity: 0.7;
            }
        }

        .btn-cancel-filter {
            position: relative;
            padding-top: 12px;
            padding-bottom: 2px;

            .fa-times-circle {
                position: absolute;
                top: 4px;
                right: 1px;
                background: white;
                border-radius: 20px;
                font-size: 0.8rem;
                padding: 1px;
            }

            &:disabled {
                opacity: 0.7;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/components/datagrid/FilterPanel.vue